var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main_container"},[_c('el-main',[_c('div',{staticClass:"DataModule full_height"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }